<template>
  <div>
    <a href="#" class="btn btn-primary btn-sm mb-3" @click.prevent="showForm" v-if="!formShown">
      <i class="fa fa-add"></i>
      Add
    </a>
    <a href="#" class="btn btn-light btn-sm" @click.prevent="hideForm" v-if="formShown">
      <i class="fa fa-times"></i>
      Close
    </a>
    <form @submit.prevent="onSubmit" v-if="formShown" class="my-3">
      <div class="row">
        <div class="col-3 col-md-2">
          <select class="form-control" v-model="priority">
            <option value="2">High</option>
            <option value="1">Normal</option>
            <option value="0">Low</option>
          </select>
        </div>
        <div class="col-7 col-md-8">
          <input type="text" class="form-control" v-model="title" ref="titleInput" @keydown="onTitleKeypress" />
        </div>
        <div class="col-2">
          <button type="submit" class="btn btn-primary btn">Add</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
 import {showError} from 'perform-base/js/flashes';

 export default {
   props: [
     'selectedProject',
   ],
   created() {
     if (this.selectedProject) {
       this.projectId = this.selectedProject;
     }
   },

   data() {
     return {
       title: '',
       projectId: '',
       priority: 1,
       formShown: false,
     };
   },

   methods: {
     onSubmit(e) {
       this.$store.dispatch('createTask', {
         title: this.title,
         projectId: this.projectId,
         priority: this.priority,
       }).then(json => {
         this.$store.commit('addTask', json.task);
         this.title = '';
       }).catch(() => {
         showError('An error occurred creating this task. Try again later.');
       });
     },
     onTitleKeypress(e) {
       if (e.key === 'ArrowUp') {
         if (this.priority < 2) {
           this.priority++;
         }
         e.preventDefault();
       }
       if (e.key === 'ArrowDown') {
         if (this.priority > 0) {
           this.priority--
         }
         e.preventDefault();
       }
     },
     showForm() {
       this.formShown = true;
       this.$nextTick(() => {
         this.$refs.titleInput.focus();
       });
     },
     hideForm() {
       this.formShown = false;
     }
   }
 }
</script>



// WEBPACK FOOTER //
// assets/js/components/TaskAdder.vue